module.exports = __webpack_public_path__ + "static/hero-home-large-82bd70f646bafb550b529501f3075e1a.png";